/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect, useState} from "react";
import {Toaster} from "react-hot-toast";
import {Link} from "react-router-dom";
import "jspdf-autotable";
import Pagination from "../../../Components/Common/Pagination";
import AppContainer from "../../../Components/Structure/AppContainer";
import TableHeader from "../../../Components/Common/TableHeader";
import Loader from "../../../Components/Common/Loader";
import ajaxStudent from "../../../util/remote/ajaxStudent";
import useStateCallback from "../../../util/customHooks/useStateCallback";
import * as XLSX from "xlsx";
import SchoolContext from "../../../Context/SchoolContext";
import Select from "react-select";
import ajaxStudentGroup from "../../../util/remote/ajaxStudentGroup";
import PrintFilterForm4 from "../../../Components/Students/AdminProfile/PrintFilterForm4";

function NoContactsPage() {
  
    const [modal, setModal] = useStateCallback(false);
    const [noContactList, setNoContactList] = useState([]);
    const [printableList, setPrintableList] = useState([]);
    const {schoolList} = useContext(SchoolContext); 
    const [school, setSchool] = useState("");
    const [page, setPage] = useState(1);
    const [meta, setMeta] = useState("");
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [group, setGroup] = useState("");

    const [first, setFirst] = useState("");
    const [groupList, setGroupList] = useState(false);
  
    useEffect(() => {
        if (school) {
            getGroups(school);
        } else {
            setGroupList([]);
        }
    }, [school]);

  const getStudentList = async () => {
    setNoContactList([]);
    setLoading(true);
    const server_response = await ajaxStudent.listAllNoContactStudents(page);
    setLoading(false);
    if (server_response.status === "OK") {
      setFirst(server_response.details.meta.offset);
      setMeta(server_response.details.meta.totalPages);
      setNoContactList(server_response.details.data || []);
    } else {
      setNoContactList([]);
    }
  };

  const searchStudentList = async (e) => {
    if (e) {
      e.preventDefault();
    }
    setLoading2(true);
    const server_response = await ajaxStudent.searchAllNoContactStudents(page, school, group);
    setLoading2(false);
    if (server_response.status === "OK") {
      setFirst(server_response.details.meta.offset);
      setMeta(server_response.details.meta.totalPages);
      setNoContactList(server_response.details.data || []);
    } else {
      setNoContactList([]);
    }
  };

  const getGroups = async (school) => {
          const server_response = await ajaxStudentGroup.fetchGroupList(school);
          if (server_response.status === "OK") {
              setGroupList(server_response.details);
          }
          else {
              setGroupList([]);
          }
    };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };
  
  useEffect(() => {
    if (group || school) {
      searchStudentList();
    }else {
      getStudentList(page);
    }
  }, [page]);

  const setStudents = (e) => {
    e.preventDefault();
    setGroup("");
    setSchool("")
    setPage(1);
    getStudentList(1);
  };

  const refreshData = () => {
    getStudentList(1);
  };

  const handleModal = () => {
    setModal(false, () =>
      setModal(
        <PrintFilterForm4
          g={setPrintableList}
          h={exportToExcel}
          printableList={printableList}
          isOpen={true}
        />
      )
    );
  };

  const exportToExcel = (data) => {
        const worksheetData = (data || []).map((item) => ({
          "Names": item.user,
          "School": item.school,
          "Student Class": item.group
         }));
      
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Student List (No Contacts)");
      
        XLSX.writeFile(workbook, "no_contact_student_list.xlsx");
  };

  
  return (

    <AppContainer title="Students Without Contacts">
        <Toaster position="top-center" reverseOrder={false} />
        {modal}
        <div className="row">
            <div className="col-lg-12">
                <div className="card custom-card">
                    <div className="card-body map-card">
                        <div class="heading-layout1 mg-b-25">
                            <TableHeader
                                title="Students Without Contacts"
                                subtitle="List of all the students with no contacts sorted in ascending order"
                            />
                            <div class="dropdown">
                                <Link class="dropdown-toggle"  role="button" data-toggle="dropdown" aria-expanded="false">...</Link>

                                <div class="dropdown-menu dropdown-menu-right">
                                    <Link class="dropdown-item" onClick={handleModal} ><i class="fas fa-file-export"></i>Export</Link>
                                    <Link class="dropdown-item" onClick={refreshData} ><i class="fas fa-redo-alt text-orange-peel"></i>Refresh</Link> 
                                </div>
                            </div>
                        </div>

    <form className="mg-t-20" onSubmit={searchStudentList}>
      <div className="row gutters-8">
        <div className="col-9-xxxl col-lg-9 col-12 form-group">
          <div className="row">
          
            <div className="col-lg-6 mt-2">
            <Select
                onChange={(e) => setSchool(e.school_id)}
                getOptionLabel={(option) => option.school_name}
                getOptionValue={(option) => option.school_id}
                isSearchable
                placeholder="Select school..."
                options={Array.isArray(schoolList) ? schoolList : []}
                value={
                        school === "" ? null
                          : Array.isArray(schoolList) &&
                            schoolList.find((value) => value.school_id === school)
                      }
                
            />
            </div>
            {school &&<div className="col-lg-6 mt-2">
              <Select
                      onChange={(e) => setGroup(e.group_id)}
                      getOptionLabel={(option) => option.group_name}
                      getOptionValue={(option) => option.group_id}
                      isSearchable
                      placeholder="Select class..."
                      options={Array.isArray(groupList) ? groupList : []}
                      value={
                        group === ""? null: Array.isArray(groupList) &&
                        groupList.find((value) => value.group_id === group)
                      }
                    />
            </div>}
            
            
            
          </div>
        </div>

        <div className="col-3-xxxl col-lg-3 col-12 form-group">
          <button
            type="submit"
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue ml-2"
          >
            SEARCH
          </button>
          <button
            type="button"
            onClick={setStudents}
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-martini mt-2"
          >
            RESET
          </button>
        </div>
      </div>
      </form>

                        <div className="border-top mt-3"></div>
                        <div className="table-responsive">
                            {loading || loading2 ? (
                                <Loader />
                            ) : (
                                <table className="table display data-table text-nowrap">
                                    <thead>
                                        <tr>
                                            <th>No.</th>
                                            <th>Name</th>
                                            <th>Student Code</th>
                                            <th>School</th>
                                            <th>Class</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {noContactList.length > 0 ? (
                                            noContactList.map((item, index) => (
                                            <tr key={index}>
                                                <td style={{width:"5px"}}>{index + first + 1}</td>
                                                <td>
                                                    <Link to={`/students/profile/${item.student_id}/${item.user_id}`}>
                                                    {item.user}
                                                    </Link>
                                                </td>
                                                <td className="text-dark">{item.username}</td>
                                                <td className="text-dark">{item.school}</td>
                                                <td className="text-dark">{item.group}</td>

                                            </tr>
                                            ))
                                        ) : 
                                        (
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: "center" }}>
                                                    No students without contacts yet.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            )}
                        </div>

                        <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
                    
                    </div>
                </div>
            </div>
        </div>
    </AppContainer>
  );
}

export default NoContactsPage;